<svg class="svg_icon--down_obtuse_chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>.svg_icon--down_obtuse_chevron .icon{fill:currentColor;}</style>
  </defs>
  <g>
    <path class="icon" d="M49.8,65.5c-1,0-2-0.2-2.8-0.7l-31.7-17c-2.9-1.6-4-5.2-2.4-8.1c1.6-2.9,5.2-4,8.1-2.4l28.9,15.5l28.9-15.5
	c2.9-1.6,6.6-0.5,8.1,2.5c1.6,2.9,0.5,6.6-2.5,8.1l-31.8,17C51.8,65.2,50.8,65.5,49.8,65.5z"/>
  </g>
</svg>